var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import Close from "@irati/ui/src/Close";
import Flex from "@irati/ui/src/Flex";
import Button from "@irati/ui/src/Button";
import { LangLoader, FormattedMessage, injectIntl } from "@irati/utils/lang";
import { PLATFORM } from "@irati-web/app/src/routeConfig";
import { ToolTipContainer, ProgressCircle, RelaDiv } from "./styled";
var CustomToolTip = /** @class */ (function (_super) {
    __extends(CustomToolTip, _super);
    function CustomToolTip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomToolTip.prototype.render = function () {
        var _a = this.props, currentStepIndex = _a.index, Content = _a.step.Content, size = _a.size, backProps = _a.backProps, primaryProps = _a.primaryProps, tooltipProps = _a.tooltipProps, isLastStep = _a.isLastStep, closeProps = _a.closeProps;
        var isFirstStep = currentStepIndex === 0;
        return (React.createElement(ToolTipContainer, __assign({}, tooltipProps),
            React.createElement(RelaDiv, null,
                React.createElement(Close, __assign({}, closeProps))),
            React.createElement(LangLoader, { bucket: PLATFORM },
                React.createElement(Content, null),
                React.createElement(Flex, { justifyContent: "space-between", alignItems: "center" },
                    React.createElement(Flex, { justifyContent: "center" }, new Array(size).fill(0).map(function (_, index) {
                        return React.createElement(ProgressCircle, { key: "tourStepProgressCircle(" + (index + 1) + "/" + size + ")", active: currentStepIndex === index });
                    })),
                    React.createElement(Flex, { alignItems: "center" },
                        !isFirstStep && (React.createElement(Button, __assign({}, backProps, { tertiary: true, small: true, marginRight: 1 }),
                            React.createElement(FormattedMessage, { id: "platform.tour.buttons.back" }))),
                        !isLastStep && (React.createElement(Button, __assign({}, primaryProps, { primary: true, small: true }),
                            React.createElement(FormattedMessage, { id: "platform.tour.buttons.next" }))),
                        isLastStep && (React.createElement(Button, __assign({}, primaryProps, { primary: true, small: true }),
                            React.createElement(FormattedMessage, { id: "platform.tour.buttons.finish" }))))))));
    };
    return CustomToolTip;
}(PureComponent));
export default injectIntl(CustomToolTip);
